// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"SpinnerCustom_spinnerContainer__EpglD"};